import { combineReducers } from "redux";
import Exam from "./ExamReducers";
import User from "./UserReducer";
import * as actionType from "../actions/actionTypes";

const appReducer = combineReducers({
	Exam,
	User,
});

const rootReducer = (state, action) => {
	if (action.type === actionType.USER_LOGOUT) {
		state = undefined;
	}
	return appReducer(state, action);
};

export default rootReducer;
